<div *ngIf="selectableFeaturesGroups" class="wrapper">
  <div class="popup-header-wrapper">
    <div class="popup-title">{{ '+HEMS.PARAMETERS_POPUP.TITLE' | translate }}</div>
    <div class="popup-summary">
      {{
        '+HEMS.PARAMETERS_POPUP.PARAMETER_COUNT'
          | translate: { parametersCount: parametersSelected }
      }}
      <span *ngIf="!isThermalFlow">
        {{ '+HEMS.PARAMETERS_POPUP.UNIT_COUNT' | translate: { unitsCount: unitsSelected } }}</span
      >
    </div>
  </div>

  <div class="features-group-wrapper">
    <div
      class="features-group"
      *ngFor="let featuresGroup of selectableFeaturesGroups"
      [ngClass]="{ subgroup: isThermalFlow }"
    >
      <span class="features-group-title">{{ featuresGroup.groupKey | translate }}</span>
      <div *ngFor="let feature of featuresGroup.features">
        <mat-checkbox
          class="custom-layout"
          gtm="onSelect"
          gtmAction="Feature to display on chart"
          gtmCategory="hems"
          [checked]="feature.checked"
          [disabled]="isCheckboxDisabled(feature)"
          (change)="toggleFeatureSelection(feature)"
        >
          {{ feature.displayName }}
          <span *ngIf="feature.unit" class="feature-unit">{{ feature.unit }}</span>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <button
    gtm="onConfirm"
    gtmAction="Apply parameters"
    gtmCategory="hems"
    (click)="onApplyParameters()"
    class="btn-apply"
    mat-raised-button
    color="primary"
  >
    {{ '+HEMS.PARAMETERS_POPUP.APPLY_BTN' | translate }}
  </button>
  <mat-icon gtm="onClose" gtmAction="Close" gtmCategory="Hems" class="btn-close" (click)="onClose()"
    >close</mat-icon
  >
</div>
